import { render } from "./LoaderComponent.vue?vue&type=template&id=c6aaeeb4&scoped=true&ts=true"
import script from "./LoaderComponent.vue?vue&type=script&lang=ts"
export * from "./LoaderComponent.vue?vue&type=script&lang=ts"

import "./LoaderComponent.vue?vue&type=style&index=0&id=c6aaeeb4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6aaeeb4"]])

export default __exports__